<template>
<div class="site container hfeed">
  <HeadNav selectedLanguage="en" page="legal" />
  <article class="seo-topic-page">
    <SeoBreadcrumb :items="breadcrumbItems" />
    <section class="blog-content">
      <h1>DMCA Policy</h1>
      <p>
        <router-link to="/">GB-Wave.com</router-link>
        respects intellectual property rights and responds to valid copyright concerns.
      </p>
      <p>
        If you believe that content on our website infringes on your copyright, please contact us with the following information:
      </p>
      <ul>
        <li>Your name and contact details</li>
        <li>Description of the copyrighted work</li>
        <li>URL of the content in question</li>
        <li>Reason for the removal request</li>
        <li>Proof of ownership or authorization</li>
      </ul>
      <p>After receiving a valid request, we will review the information and take appropriate action.</p>
      <p>Contact:</p>
      <p><a href="mailto:support@gb-wave.com">support@gb-wave.com</a></p>
    </section>
  </article>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/seo-guide-page.scss';
import HeadNav from '@/components/HeadNav.vue';
import SeoBreadcrumb from '@/components/SeoBreadcrumb.vue';

export default {
  name: 'DmcaPage',
  components: { HeadNav, SeoBreadcrumb },
  data() {
    return {
      breadcrumbItems: [
        { label: 'Home', to: { name: 'en-gb' } },
        { label: 'DMCA Policy', current: true },
      ],
    };
  },
};
</script>
